var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownDarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60157 0.906907C7.79947 1.11612 7.79947 1.45531 7.60157 1.66452L4.35833 5.09309C4.16043 5.3023 3.83957 5.3023 3.64167 5.09309L0.398425 1.66452C0.200525 1.45531 0.200525 1.11612 0.398425 0.906907C0.596326 0.697698 0.917187 0.697698 1.11509 0.906907L4 3.95667L6.88491 0.906907C7.08281 0.697698 7.40367 0.697698 7.60157 0.906907Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDarker);
export default __webpack_public_path__ + "static/media/arrowDownDarker.0ef1f6ca13bc3186e72fbbe8e52a8406.svg";
export { ForwardRef as ReactComponent };